import React,{ useCallback, useState } from 'react';

const usePopUp = () => {
    const [isOpen, setIsOpen] = useState(false);

    const handleClose = useCallback(() => {
        setIsOpen(false);
    }, [setIsOpen])

    const handleOpen = useCallback(() => {
        setIsOpen(true);
    }, [setIsOpen])

    return {handleClose, handleOpen, isOpen}
}

export default usePopUp;